<template>
  <!--
    Stay / TV content behind call overlays. Figma: blurred room + 40% black scrim.
    Gradient stops use GetWell palette hex values (variables.module.scss).
  -->
  <div class="patient-bg">
    <div class="patient-bg__photo" />
    <div class="patient-bg__overlay" />
  </div>
</template>

<script setup lang="ts">
// Presentational only
</script>

<style scoped>
/* GW tokens: $gw-mauve #bc7aa9, $gw-info-blue #1751D7, $gw-validation-green #25883b,
   $gw-orange #ffb471, $gw-dark-purple #291758, $black #222 */
.patient-bg {
  position: absolute;
  inset: 0;
  overflow: hidden;
}

.patient-bg__photo {
  position: absolute;
  inset: -20px;
  background-image:
    radial-gradient(ellipse 80% 70% at 18% 50%, rgba(188, 122, 169, 0.55) 0%, transparent 55%),
    radial-gradient(ellipse 55% 50% at 72% 28%, rgba(23, 81, 215, 0.4) 0%, transparent 55%),
    radial-gradient(ellipse 60% 65% at 55% 78%, rgba(37, 136, 59, 0.35) 0%, transparent 55%),
    radial-gradient(ellipse 40% 40% at 40% 40%, rgba(255, 180, 113, 0.3) 0%, transparent 45%),
    linear-gradient(160deg, #222222 0%, #2a2040 50%, #291758 100%);
  filter: blur(24px);
  transform: scale(1.05);
}

.patient-bg__overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
}
</style>
